/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
// other
// import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import DateInput from "../../../components/InputWrapper/DateInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import SyainService from "../../../service/master/syain/syainService"

import { 区分分類コード } from "../../../constant/enum/codes"

import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  TBusyoIdoRirekiData,
  TSyainInfoGetRes,
  TSyainRegisterPostReq,
  TSyainUpdatePutReq,
} from "../../../service/master/syain/TSyain"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import {
  TSyainRegisterPostReqSchema,
  TSyainUpdatePutReqSchema,
} from "../../../service/master/syain/syainSchema"
//import { e社員区分 } from "../../../constant/enum/syain"
import { RootState } from "../../../globalStore/rootreducer"
import { メニューコード } from "../../../constant/menuCode"
import validateConstant from "../../../constant/validateConstant"
import WarekiInput from "../../../components/InputWrapper/WarekiInput"
import { e社員区分 } from "../../../constant/enum/syain"
import AuthService from "../../../service/auth/authService"

/**
 *　社員マスタ登録
 * @returns
 */
const MasterSyainRegister = () => {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.社員マスタ登録
      )?.読み取り専用フラグ
  )

  const システム管理者フラグ = useSelector(
    (rootState: RootState) =>
      rootState.user.LoginUserInfo.社員区分コード === e社員区分.システム管理者
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 表示項目のstate
  const [社員コード, set社員コード] = useState<string>("")
  const [社員氏名, set社員氏名] = useState<string>("")
  const [社員氏名カナ, set社員氏名カナ] = useState<string>("")
  const [性別区分コード, set性別区分コード] = useState<string | null>("")
  const [社員区分コード, set社員区分コード] = useState<string | null>("")
  const [生年月日, set生年月日] = useState<string | null>()
  const [血液型区分コード, set血液型区分コード] = useState<string | null>("")
  const [入社区分コード, set入社区分コード] = useState<string | null>("")
  const [入社年月日, set入社年月日] = useState<string | null>()
  const [請求担当フラグ, set請求担当フラグ] = useState<number | null>()
  const [部所コード, set部所コード] = useState<string | null>("")
  const [郵便番号, set郵便番号] = useState<string>("")
  const [住所, set住所] = useState<string>("")
  const [電話番号, set電話番号] = useState<string>("")
  const [携帯電話番号, set携帯電話番号] = useState<string>("")
  const [備考, set備考] = useState<string>("")
  const [メールアドレス, setメールアドレス] = useState<string>("")
  const [社員カードID, set社員カードID] = useState<string>("")
  const [退職年月日, set退職年月日] = useState<string | null>()
  const [退職事由, set退職事由] = useState<string>("")

  const [ESTRA社員コード, setESTRA社員コード] = useState<string>("")
  const [光英社員コード, set光英社員コード] = useState<string>("")

  const [部所更新判定, set部所更新判定] = useState<boolean>(false)

  const [社員区分更新判定, set社員区分更新判定] = useState<boolean>(false)

  const [更新日時, set更新日時] = useState<string>("")
  const [最終更新ID, set最終更新ID] = useState<string>()
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // エラー表示用フラグ
  const [isInvalid社員コード, setIsInvalid社員コード] = useState<boolean>(false)
  const [isInvalid社員氏名, setIsInvalid社員氏名] = useState<boolean>(false)
  const [isInvalid社員氏名カナ, setIsInvalid社員氏名カナ] =
    useState<boolean>(false)
  const [isInvalid性別区分コード, setIsInvalid性別区分コード] =
    useState<boolean>(false)
  const [isInvalid社員区分コード, setIsInvalid社員区分コード] =
    useState<boolean>(false)
  const [isInvalid生年月日, setIsInvalid生年月日] = useState<boolean>(false)
  const [isInvalid血液型区分コード, setIsInvalid血液型区分コード] =
    useState<boolean>(false)
  const [isInvalid入社区分コード, setIsInvalid入社区分コード] =
    useState<boolean>(false)
  const [isInvalid入社年月日, setIsInvalid入社年月日] = useState<boolean>(false)
  const [, setIsInvalid請求担当フラグ] = useState<boolean>(false)
  const [isInvalid部所コード, setIsInvalid部所コード] = useState<boolean>(false)
  const [isInvalid郵便番号, setIsInvalid郵便番号] = useState<boolean>(false)
  const [isInvalid住所, setIsInvalid住所] = useState<boolean>(false)
  const [isInvalid電話番号, setIsInvalid電話番号] = useState<boolean>(false)
  const [isInvalid携帯電話番号, setIsInvalid携帯電話番号] =
    useState<boolean>(false)
  const [isInvalid備考, setIsInvalid備考] = useState<boolean>(false)
  const [isInvalidメールアドレス, setIsInvalidメールアドレス] =
    useState<boolean>(false)
  const [isInvalid退職年月日, setIsInvalid退職年月日] = useState<boolean>(false)
  const [isInvalid退職事由, setIsInvalid退職事由] = useState<boolean>(false)
  const [isInvalidESTRA社員コード, setIsInvalidESTRA社員コード] =
    useState<boolean>(false)
  const [isInvalid光英社員コード, setIsInvalid光英社員コード] =
    useState<boolean>(false)
  const [, setIsInvalid更新日時] = useState<boolean>(false)

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#region [comboboxState]

  // 社員区分
  const [社員区分ComboBox, set社員区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [社員区分IsLoadEnded, set社員区分IsLoadEnded] = useState<boolean>(false)

  // 性別区分
  const [性別区分ComboBox, set性別区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [性別区分IsLoadEnded, set性別区分IsLoadEnded] = useState<boolean>(false)

  // 血液型区分
  const [血液型区分ComboBox, set血液型区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [血液型区分IsLoadEnded, set血液型区分IsLoadEnded] =
    useState<boolean>(false)

  // 入社区分
  const [入社区分ComboBox, set入社区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [入社区分IsLoadEnded, set入社区分IsLoadEnded] = useState<boolean>(false)

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  //#endregion

  const [isUpsertConfirmModalShow, setIsUpsertConfirmModalShow] =
    useState(false)
  const [isResetConfirmModalShow, setIsResetConfirmModalShow] = useState(false)
  const [isResetConfirmAgainModalShow, setIsResetConfirmAgainModalShow] =
    useState(false)

  // グリッド関連
  const gridRef = useRef<wjrGrid.FlexGrid>(null)
  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }
  // グリッドのフォーマット
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  // 部所異動履歴CollectionView
  const createCollectionViewBusyoIdoRireki = (data: TBusyoIdoRirekiData[]) =>
    new wjcCore.CollectionView(data)
  const [itemsSourceBusyoIdoRireki, setItemsSourceBusyoIdoRireki] =
    useState<wjcCore.CollectionView<[TBusyoIdoRirekiData]>>()

  //#endregion

  //#region [method]

  /**
   * データ取得
   */
  const getData = async (id: string) => {
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const service = new SyainService()

      const res = (await service.get(id)) as TApiResponse<TSyainInfoGetRes>

      if (res.data) {
        set社員コード(res.data.社員コード)
        set社員氏名(res.data.社員氏名)
        set社員氏名カナ(res.data.社員氏名カナ)
        set性別区分コード(res.data.性別区分コード)
        set社員区分コード(res.data.社員区分コード)
        // 2パターンの入力に耐えるため画面表示用のstateを追加
        set生年月日(res.data.生年月日)
        set血液型区分コード(res.data.血液型区分コード)
        set入社区分コード(res.data.入社区分コード)
        set入社年月日(res.data.入社年月日)
        set請求担当フラグ(res.data.請求担当フラグ)
        set部所コード(res.data.部所コード)
        set郵便番号(res.data.郵便番号)
        set住所(res.data.住所)
        set電話番号(res.data.電話番号)
        set携帯電話番号(res.data.携帯電話番号)
        set備考(res.data.備考)
        setメールアドレス(res.data.メールアドレス)
        set社員カードID(res.data.社員カードID)
        set退職年月日(res.data.退職年月日)
        set退職事由(res.data.退職事由)
        setESTRA社員コード(res.data.ESTRA社員コード)
        set光英社員コード(res.data.光英社員コード)
        set更新日時(res.data.更新日時)
        set最終更新ID(
          res.data.更新ユーザID ? res.data.更新ユーザID.toString() : ""
        )

        // 編集モードでは部所コード、社員区分を変更不可に設定
        set部所更新判定(true)
        set社員区分更新判定(true)

        // 部所異動履歴グリッド表示
        setItemsSourceBusyoIdoRireki(
          createCollectionViewBusyoIdoRireki(res.data.部所異動履歴リスト)
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
    }
  }

  /**
   * 登録アイテム生成
   */
  const getPostReq = (): TSyainRegisterPostReq => {
    return {
      社員コード,
      社員氏名,
      社員氏名カナ,
      性別区分コード: 性別区分コード ?? "",
      社員区分コード: 社員区分コード ?? "",
      生年月日: 生年月日 ?? "",
      血液型区分コード: 血液型区分コード ?? "",
      入社区分コード: 入社区分コード ?? "",
      入社年月日: 入社年月日 ?? "",
      請求担当フラグ: 請求担当フラグ ? 1 : 0,
      部所コード: 部所コード ?? "",
      郵便番号,
      住所,
      電話番号,
      携帯電話番号,
      メールアドレス,
      備考,
      退職年月日: 退職年月日 ?? "",
      退職事由,
      ESTRA社員コード: ESTRA社員コード ?? "",
      光英社員コード: 光英社員コード ?? "",
    }
  }

  /**
   * 更新アイテム生成
   */
  const getPutReq = (): TSyainUpdatePutReq => {
    return {
      社員コード,
      社員氏名,
      社員氏名カナ,
      性別区分コード: 性別区分コード ?? "",
      社員区分コード: 社員区分コード ?? "",
      生年月日: 生年月日 ?? "",
      血液型区分コード: 血液型区分コード ?? "",
      入社区分コード: 入社区分コード ?? "",
      入社年月日: 入社年月日 ?? "",
      請求担当フラグ: 請求担当フラグ ? 1 : 0,
      部所コード: 部所コード ?? "",
      郵便番号,
      住所,
      電話番号,
      携帯電話番号,
      メールアドレス,
      備考,
      退職年月日: 退職年月日 ?? "",
      退職事由,
      ESTRA社員コード: ESTRA社員コード ?? "",
      光英社員コード: 光英社員コード ?? "",
      更新日時,
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    let data
    if (id) {
      schema = TSyainUpdatePutReqSchema
      data = getPutReq()
    } else {
      schema = TSyainRegisterPostReqSchema
      data = getPostReq()
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors
      const errorMessages: string[] = []
      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        errorMessages.push(
          ...errors.filter((e) => e.message != null).map((e) => e.message ?? "")
        )
      }
      disPatch(setWarningAlerts([...errorMessages]))
      return
    }

    setIsUpsertConfirmModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid社員コード(errorProperties.includes("社員コード"))
    setIsInvalid社員氏名(errorProperties.includes("社員氏名"))
    setIsInvalid社員氏名カナ(errorProperties.includes("社員氏名カナ"))
    setIsInvalid性別区分コード(errorProperties.includes("性別区分コード"))
    setIsInvalid社員区分コード(errorProperties.includes("社員区分コード"))
    setIsInvalid生年月日(errorProperties.includes("生年月日"))
    setIsInvalid血液型区分コード(errorProperties.includes("血液型区分コード"))
    setIsInvalid入社区分コード(errorProperties.includes("入社区分コード"))
    setIsInvalid入社年月日(errorProperties.includes("入社年月日"))
    setIsInvalid請求担当フラグ(errorProperties.includes("請求担当フラグ"))
    setIsInvalid部所コード(errorProperties.includes("部所コード"))
    setIsInvalid郵便番号(errorProperties.includes("郵便番号"))
    setIsInvalid住所(errorProperties.includes("住所"))
    setIsInvalid電話番号(errorProperties.includes("電話番号"))
    setIsInvalid携帯電話番号(errorProperties.includes("携帯電話番号"))
    setIsInvalid備考(errorProperties.includes("備考"))
    setIsInvalidメールアドレス(errorProperties.includes("メールアドレス"))
    setIsInvalid退職年月日(errorProperties.includes("退職年月日"))
    setIsInvalid退職事由(errorProperties.includes("退職事由"))
    setIsInvalidESTRA社員コード(errorProperties.includes("ESTRA社員コード"))
    setIsInvalid光英社員コード(errorProperties.includes("光英社員コード"))
    setIsInvalid更新日時(errorProperties.includes("更新日時"))
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      if (
        社員コード == null ||
        社員氏名 == null ||
        社員区分コード == null ||
        部所コード == null
      )
        return

      const service = new SyainService()
      let res: TApiResponse<boolean>

      if (id) {
        // 更新
        res = await service.put(id, getPutReq())
      } else {
        // 登録
        res = await service.post(getPostReq())
      }

      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`社員の${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsUpsertConfirmModalShow(false)
    }
  }

  /**
   * 送信
   */
  const reset = async () => {
    try {
      if (id == null) return

      const service = new AuthService()
      let res = await service.resetPassword({
        社員ID: id,
      })

      if (res) {
        isPrompt.current = false

        showInfoToast(`パスワードのリセット処理が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
      util.goToPageTop()
    } finally {
      setIsResetConfirmAgainModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    //TODO: API より取得

    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set区分ItemSource(区分マスタRes.data)
      set部所ItemSource(部所ListRes.data)
      // id存在時はデータを取得し更新
      if (id) {
        getData(id).finally(() => {
          disPatch(画面ロック解除())
        })
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      } else {
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      }
    })
  }, [])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">社員マスタ{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-70rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 社員 */}
                  <MasterRegisterFormRow
                    label="社員コード"
                    isRequired={true}
                    remarks={<div>半角英数字4桁まで</div>}>
                    <div className="w-6rem">
                      <TextInput
                        id="社員コード"
                        name="社員コード"
                        value={社員コード}
                        setValue={set社員コード}
                        maxLength={4}
                        className={isInvalid社員コード ? "is-error" : ""}
                        autoFocus={true}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  <br />
                  {/* ESTRA社員コード */}
                  <MasterRegisterFormRow label="ESTRA社員コード">
                    <div className="w-15rem">
                      <TextInput
                        id="ESTRA社員コード"
                        name="ESTRA社員コード"
                        value={ESTRA社員コード}
                        setValue={setESTRA社員コード}
                        maxLength={validateConstant.LENGTH.CSVフィールド}
                        className={isInvalidESTRA社員コード ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 光英社員コード */}
                  <MasterRegisterFormRow label="光英社員コード">
                    <div className="w-15rem">
                      <TextInput
                        id="光英社員コード"
                        name="光英社員コード"
                        value={光英社員コード}
                        setValue={set光英社員コード}
                        maxLength={validateConstant.LENGTH.CSVフィールド}
                        className={isInvalid光英社員コード ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  <br />
                  {/* 社員氏名 */}
                  <MasterRegisterFormRow label="氏名（漢字）" isRequired={true}>
                    <div className="w-15rem">
                      <TextInput
                        id="社員氏名"
                        name="社員氏名"
                        value={社員氏名}
                        setValue={set社員氏名}
                        maxLength={100}
                        className={isInvalid社員氏名 ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 社員氏名カナ */}
                  <MasterRegisterFormRow
                    label="氏名（フリガナ）"
                    isRequired={false}
                    remarks={<div>全角カナで入力してください</div>}>
                    <div className="w-15rem">
                      <TextInput
                        id="社員氏名カナ"
                        name="社員氏名カナ"
                        value={社員氏名カナ}
                        setValue={set社員氏名カナ}
                        maxLength={200}
                        className={isInvalid社員氏名カナ ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 部所 */}
                  <MasterRegisterFormRow label="所属部所" isRequired={true}>
                    <ComboBox.Busyo
                      isReadOnly={部所更新判定}
                      itemsSource={部所ItemSource}
                      isLoadEnded={部所IsLoadEnded}
                      setIsLoadEnded={set部所IsLoadEnded}
                      isRequired={true}
                      isEmpty={true}
                      selectedValue={部所コード}
                      setSelectedValue={set部所コード}
                      ComboBox={部所ComboBox}
                      setComboBox={set部所ComboBox}
                      className={
                        isInvalid部所コード ? "is-error" : ""
                      }></ComboBox.Busyo>
                  </MasterRegisterFormRow>
                  {/* 社員区分 */}
                  <MasterRegisterFormRow label="社員区分" isRequired={true}>
                    <ComboBox.Kubun
                      isReadOnly={社員区分更新判定}
                      分類コード={区分分類コード.社員_乗務員.社員区分}
                      isLoadEnded={社員区分IsLoadEnded}
                      setIsLoadEnded={set社員区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired={true}
                      isEmpty={true}
                      itemsSource={区分ItemSource}
                      selectedValue={社員区分コード}
                      setSelectedValue={set社員区分コード}
                      ComboBox={社員区分ComboBox}
                      setComboBox={set社員区分ComboBox}
                      className={
                        isInvalid社員区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 性別区分 */}
                  <MasterRegisterFormRow label="性別区分" isRequired={false}>
                    <ComboBox.Kubun
                      分類コード={区分分類コード.社員_乗務員.性別区分}
                      isLoadEnded={性別区分IsLoadEnded}
                      setIsLoadEnded={set性別区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired={false}
                      isEmpty={true}
                      itemsSource={区分ItemSource}
                      selectedValue={性別区分コード}
                      setSelectedValue={set性別区分コード}
                      ComboBox={性別区分ComboBox}
                      setComboBox={set性別区分ComboBox}
                      className={
                        isInvalid性別区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 生年月日 */}
                  <MasterRegisterFormRow label="生年月日" isRequired={false}>
                    <WarekiInput
                      name="生年月日"
                      value={生年月日}
                      setValue={set生年月日}
                      isInvalidValue={isInvalid生年月日}></WarekiInput>
                  </MasterRegisterFormRow>
                  {/* 血液型区分 */}
                  <MasterRegisterFormRow label="血液型" isRequired={false}>
                    <ComboBox.Kubun
                      分類コード={区分分類コード.社員_乗務員.血液型区分}
                      isLoadEnded={血液型区分IsLoadEnded}
                      setIsLoadEnded={set血液型区分IsLoadEnded}
                      isAllSelect={false}
                      isEmpty={true}
                      isRequired={false}
                      itemsSource={区分ItemSource}
                      selectedValue={血液型区分コード}
                      setSelectedValue={set血液型区分コード}
                      ComboBox={血液型区分ComboBox}
                      setComboBox={set血液型区分ComboBox}
                      className={
                        isInvalid血液型区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 入社区分 */}
                  <MasterRegisterFormRow label="有休付与区分" isRequired={true}>
                    <ComboBox.Kubun
                      分類コード={区分分類コード.社員_乗務員.入社区分}
                      isLoadEnded={入社区分IsLoadEnded}
                      setIsLoadEnded={set入社区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired={true}
                      isEmpty={true}
                      itemsSource={区分ItemSource}
                      selectedValue={入社区分コード}
                      setSelectedValue={set入社区分コード}
                      ComboBox={入社区分ComboBox}
                      setComboBox={set入社区分ComboBox}
                      className={
                        isInvalid入社区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 入社年月日 */}
                  <MasterRegisterFormRow label="入社日" isRequired={true}>
                    <WarekiInput
                      name="入社年月日"
                      value={入社年月日}
                      isRequired={true}
                      setValue={set入社年月日}
                      isInvalidValue={isInvalid入社年月日}></WarekiInput>
                  </MasterRegisterFormRow>
                  {/* 請求担当フラグ */}
                  <MasterRegisterFormRow
                    label="請求担当フラグ"
                    isRequired={false}
                    remarks={
                      <div>
                        請求担当者にチェック（事務員・運行管理者のみ有効）
                      </div>
                    }>
                    <CheckInput
                      id="請求担当フラグ"
                      type={"switch"}
                      label={""}
                      setValue={(v) => {
                        v === 1 ? set請求担当フラグ(v) : set請求担当フラグ(0)
                      }}
                      value={請求担当フラグ ?? 0}
                    />
                  </MasterRegisterFormRow>
                  {/* 郵便番号 */}
                  <MasterRegisterFormRow
                    label="郵便番号"
                    isRequired={false}
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <div className="w-6rem">
                      <TextInput
                        id="郵便番号"
                        name="郵便番号"
                        value={郵便番号}
                        setValue={set郵便番号}
                        maxLength={8}
                        className={isInvalid郵便番号 ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 住所 */}
                  <MasterRegisterFormRow label="住所" isRequired={false}>
                    <div className="w-100rem">
                      <TextInput
                        id="住所"
                        name="住所"
                        value={住所}
                        setValue={set住所}
                        maxLength={100}
                        className={isInvalid住所 ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 電話番号 */}
                  <MasterRegisterFormRow
                    label="電話番号"
                    isRequired={false}
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <div className="w-15rem">
                      <TextInput
                        id="電話番号"
                        name="電話番号"
                        value={電話番号}
                        setValue={set電話番号}
                        maxLength={15}
                        className={isInvalid電話番号 ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 携帯電話番号 */}
                  <MasterRegisterFormRow
                    label="携帯番号"
                    isRequired={false}
                    remarks={<div>ハイフンあり で入力してください</div>}>
                    <div className="w-15rem">
                      <TextInput
                        id="携帯電話番号"
                        name="携帯電話番号"
                        value={携帯電話番号}
                        setValue={set携帯電話番号}
                        maxLength={15}
                        className={isInvalid携帯電話番号 ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 備考 */}
                  <MasterRegisterFormRow label="備考" isRequired={false}>
                    <TextAreaInput
                      value={備考}
                      setValue={set備考}
                      className={["w-100", isInvalid備考 && "is-error"].join(
                        " "
                      )}></TextAreaInput>
                  </MasterRegisterFormRow>
                  {/* メールアドレス */}
                  <MasterRegisterFormRow
                    label="メールアドレス"
                    isRequired={false}>
                    <div className="w-100rem">
                      <TextInput
                        id="メールアドレス"
                        name="メールアドレス"
                        value={メールアドレス}
                        setValue={setメールアドレス}
                        maxLength={254}
                        className={isInvalidメールアドレス ? "is-error" : ""}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 社員カードID */}
                  <MasterRegisterFormRow
                    label="社員カードID"
                    isRequired={false}>
                    <div className="w-100rem">
                      <TextInput
                        id="社員カードID"
                        name="社員カードID"
                        value={社員カードID}
                        setValue={set社員カードID}
                        isReadOnly={true}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 退職年月日 */}
                  <MasterRegisterFormRow label="退職日" isRequired={false}>
                    <DateInput
                      id="退職年月日"
                      value={退職年月日}
                      isRequired={false}
                      defaultValue={null}
                      setValue={set退職年月日}
                      className={isInvalid退職年月日 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 退職事由 */}
                  <MasterRegisterFormRow label="退職事由" isRequired={false}>
                    <TextAreaInput
                      value={退職事由}
                      setValue={set退職事由}
                      className={[
                        "w-100",
                        isInvalid退職事由 && "is-error",
                      ].join(" ")}></TextAreaInput>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {id && (
          <>
            <Row>
              <Col>
                更新日時: {util.date.format(更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          {!読取専用フラグ && (
            <Col xl={{ span: "auto", offset: 0 }}>
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                {id ? `更新` : `登録`}
              </Button>
            </Col>
          )}
          <Col xl={{ span: "auto" }}>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
          {システム管理者フラグ && id && (
            <Col
              xl={{ span: "auto" }}
              style={{
                marginLeft: "2rem",
              }}>
              <Button
                type="submit"
                variant="danger"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIsResetConfirmModalShow(true)
                }}>
                パスワードリセット
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <br />
            <Card className="w-95rem">
              {/* 社員部所異動履歴パネル */}
              <Card.Header>社員部所異動履歴</Card.Header>
              <Card.Body>
                <wjrGrid.FlexGrid
                  className="max-h-18rem"
                  {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                  ref={gridRef}
                  itemsSource={itemsSourceBusyoIdoRireki}
                  initialized={gridInitializedHandler}>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="所属開始日"
                    width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_SIZE}
                    header="異動日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TBusyoIdoRirekiData>
                      ) => {
                        return (
                          <>
                            {wjcCore.Globalize.format(
                              new Date(context.item.所属開始日),
                              "d"
                            )}
                          </>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    width={150}
                    binding="会社名"
                    header="会社名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    width={80}
                    binding="部所コード"
                    header="部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    width={200}
                    binding="部所名"
                    header="部所名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    width={160}
                    binding="社員区分名称1"
                    header="社員区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    width={400}
                    binding="備考"
                    header="備考"></wjrGrid.FlexGridColumn>
                </wjrGrid.FlexGrid>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isUpsertConfirmModalShow}
        hideHandler={setIsUpsertConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isResetConfirmModalShow}
        hideHandler={setIsResetConfirmModalShow}
        submitHandler={() => {
          setIsResetConfirmModalShow(false)
          setIsResetConfirmAgainModalShow(true)
        }}>
        {社員コード} : {社員氏名} さんのパスワードをリセットします。
        <br />
        よろしいですか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isResetConfirmAgainModalShow}
        hideHandler={setIsResetConfirmAgainModalShow}
        submitHandler={reset}>
        パスワードは
        <br />
        <span className="fw-bold">
          社員コード + @ + 本日の年月日(例: 0001@20230101)
        </span>
        <br />
        にリセットされます。よろしいですか？
      </ConfirmModal>
    </>
  )
}

export default MasterSyainRegister
